import { useModalShareFileV2Store } from '../../../store'
import { useGet } from '../../../hooks'
import { getPropertyDetail } from '../../../services'
import { generateMiliSecondsByMinutes } from '@wiggot/utils'

export const useShareFilePropertyV2 = () => {
  const showModalPDF = useModalShareFileV2Store((state) => state.showModalPDF)

  const setShowModalPDF = useModalShareFileV2Store(
    (state) => state.setShowModalPDF
  )

  const isOpen = useModalShareFileV2Store(
    (state) => state.modalShareFileV2.isOpen
  )
  const property = useModalShareFileV2Store(
    (state) => state.modalShareFileV2.property
  )
  const propertyId =
    useModalShareFileV2Store((state) => state.modalShareFileV2.propertyId) || ''
  const enableCallViewService = useModalShareFileV2Store(
    (state) => state.modalShareFileV2.enableCallViewService
  )

  const reset = useModalShareFileV2Store((state) => state.reset)

  const onClose = () => {
    reset()
  }

  const { data: dataProperty, isLoading } = useGet({
    queryKey: ['get-view-property', propertyId],
    queryParams: { propertyId },
    queryFn: async () => {
      const res = await getPropertyDetail({ id: propertyId })
      return res.data
    },
    options: {
      enabled: Boolean(enableCallViewService && propertyId && !property),
      staleTime: generateMiliSecondsByMinutes(30),
      gcTime: generateMiliSecondsByMinutes(30)
    }
  })

  return {
    isOpen,
    property: property ?? dataProperty,
    isLoading,
    onClose,
    showModalPDF,
    setShowModalPDF
  }
}
